import { useState } from "react";
import { Link, useNavigate, useSearchParams, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, GoogleButton, Divider } from "@/components/AuthBits";

export default function Login() {
  const [sp] = useSearchParams();
  const next = sp.get("next") || "/perfil";
  const navigate = useNavigate();
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to={next} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data);
      navigate(data.must_change_password ? "/trocar-senha" : next, { replace: true });
    } catch (err) {
      toast.error(errMsg(err));
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Entrar" subtitle="Use a mesma conta para pedir serviços e para trabalhar como prestador.">
      <GoogleButton next={next} />
      <Divider />
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div>
          <label className="po-label" htmlFor="email">E-mail</label>
          <input id="email" type="email" autoComplete="email" required className="po-input" value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email-input" />
        </div>
        <div>
          <label className="po-label" htmlFor="password">Senha</label>
          <input id="password" type="password" autoComplete="current-password" required className="po-input" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password-input" />
        </div>
        <button type="submit" disabled={busy} className="po-btn-primary w-full" data-testid="login-submit-button">
          {busy && <Loader2 className="h-6 w-6 animate-spin" />} Entrar
        </button>
      </form>
      <div className="mt-5 flex flex-col gap-3 text-lg">
        <Link to="/esqueci-senha" className="font-semibold text-orange-600 underline" data-testid="forgot-password-link">Esqueci minha senha</Link>
        <p>Não tem conta? <Link to={`/cadastro?next=${encodeURIComponent(next)}`} className="font-semibold text-orange-600 underline" data-testid="register-link">Criar conta</Link></p>
      </div>
    </AuthShell>
  );
}
